import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles the LOAD_BULK_PROCESS_MANAGEMENT_DATA_SUCCESS & LOAD_BULK_PROCESS_MANAGEMENT_DATA_FAILURE action and sets bulk process management grid data to the store
 * @param {Object} [state] The bulk process management grid data
 * @param {Object} action The action to be handled
 * @returns {Object} The bulk process management grid data
 */

export default function tenantServicesReducer(
  state = initialState.tenantServicesData,
  action
) {
  switch (action.type) {
    case actions.LOAD_TENANT_SERVICES_SUCCESS:
      // populate the uniqueKey for each item in the tenantServicesData array
      // if id is not available, generate a random number as uniqueKey
      return action.tenantServicesData.map((item) => ({
        ...item,
        uniqueKey:
          item.propertyAmenityID ??
          (parseInt(Math.random() * (99999999 - 1)) + 1) * -1,
        isProvidedByCustomary: item.isProvidedByCustomary ?? false, // Ensure nullable property is false
        isProvidedByEmployee: item.isProvidedByEmployee ?? false, // Ensure nullable property is false
        isProvidedByIndependentContractor:
          item.isProvidedByIndependentContractor ?? false, // Ensure nullable property is false
        isProvidedByTaxableReitSubsidiary:
          item.isProvidedByTaxableReitSubsidiary ?? false, // Ensure nullable property is false
        propertyAmenityName: item.propertyAmenityName ?? '', // Ensure nullable property is empty string
        serviceNameOtherDescription: item.serviceNameOtherDescription ?? '', // Ensure nullable property is empty string
        trsName: item.trsName ?? '', // Ensure nullable property is empty string
        taxableREITSubsidiaryID: item.taxableREITSubsidiaryID ?? -1, // Ensure nullable property is -1
      }));
    case actions.LOAD_TENANT_SERVICES_FAILURE:
      return state;
    default:
      return state;
  }
}
